import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from "@angular/common";

import {DomSanitizer} from "@angular/platform-browser";
import {STATUS_ACTIVE, STATUSES_NAME} from '@shared/constants';


interface IOptions {
  digit?: number,
  abs?: boolean,
  useZero?: boolean,
}

interface IStatusOptions {
  onlyCheckValue?: boolean,
  title?: string;
}

@Pipe({
  name: 'formatNumber',
  standalone: true
})
@Injectable({providedIn: 'root'})
export class FormatNumberPipe implements PipeTransform {

  constructor(
    private currencyPipe: CurrencyPipe,
  ) {

  }

  transform(value: number | string | undefined | any, opts: IOptions = {}) {
    if (value == 0 && opts.useZero) {
      return 0;
    }
    if (typeof value == undefined || isNaN(value) || value == 0) {
      return '';
    }

    if (opts.abs && typeof value == "number") {
      value = Math.abs(value);
    }

    let digitsInfo = '1.0-2';
    if (opts.digit) {
      // minIntegerDigits . minFractionDigits . maxFractionDigits
      digitsInfo = `1.0-${opts.digit}`;
    }

    return this.currencyPipe.transform(value, '', '', digitsInfo);
  }
}


@Pipe({
  name: 'formatPercent',
  standalone: true
})
@Injectable({providedIn: 'root'})
export class FormatPercentPipe implements PipeTransform {

  transform(value: string | number, isUseZero = false, digit = 2): number | string {
    if (typeof value === "string") {
      value = parseFloat(value)
    }

    if (isNaN(value) || (!isUseZero && value == 0)) return ''

    return Number(value?.toFixed(digit))
  }

}


@Pipe({
  name: 'statusPipe',
  standalone: true
})
@Injectable({providedIn: 'root'})
export class FormatStatusPipe implements PipeTransform {
  transform(status: number | string, type?: any): any {
    if (!status) {
      return '';
    }

    if (typeof status === "string") {
      status = parseInt(status);
    }

    if (type) {
      return type[status];
    }

    return STATUSES_NAME[status] ?? '';
  }
}


/**
 * onlyCheckValue:
 * - Dùng khi status truyền vào = any | number > 0
 * - Không check để lấy tên trong STATUSES_NAME nữa
 */

@Pipe({
  name: 'statusIconPipe',
  standalone: true
})
@Injectable({providedIn: 'root'})
export class FormatStatusIconPipe implements PipeTransform {
  constructor(private sanitize: DomSanitizer) {

  }

  transform(status: number, options: IStatusOptions = {}): any {
    const {onlyCheckValue = false, title = ''} = options;

    if (!(status >= 0) && !onlyCheckValue) {
      return '';
    }

    let titleTooltip = title;
    if (!onlyCheckValue) {
      titleTooltip = STATUSES_NAME[status] ?? '';
    }

    let html = `<i class="ph ph-minus-circle text-danger" ngbTooltip="${titleTooltip}"></i>`;
    if (status == STATUS_ACTIVE || (onlyCheckValue && status)) {
      html = `<i class="ph ph-check text-success" ngbTooltip="${titleTooltip}"></i>`;
    }

    return this.sanitize.bypassSecurityTrustHtml(html);
  }
}

/**
 * Pipe hỗ trợ làm tròn số
 * VD: {{1,1 | round}} => 1
 * {{2,1 | round}} => 2
 * */
@Pipe({
  name: 'round',
  standalone: true
})
@Injectable({providedIn: 'root'})
export class FormatRoundPipe implements PipeTransform {
  transform(input: number) {
    return Math.floor(input);
  }
}
